import React from 'react'

const About = () => {
  return (
    <>
    <section class="text-gray-600 body-font">
  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-col text-center w-full mb-20">
      <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900  hover:text-green-500">AJ Cricket</h1>
      <p class="lg:w-2/3 mx-auto leading-relaxed text-base  hover:text-black">Welcome to AJ Cricket, your ultimate destination for everything cricket! We're thrilled to have you join our community of passionate cricket fans.

At AJ Cricket, we aim to provide you with a comprehensive platform dedicated to the sport we all love. Whether you're a die-hard fan, a budding player, or someone looking to stay updated with the latest cricket news, scores, and analyses, you've come to the right place.

Our goal is to keep you informed and entertained with in-depth match coverage, expert insights, player interviews, match schedules, live scores, and much more. We strive to create an interactive space where cricket enthusiasts can engage, share their thoughts, and celebrate the game together.

Join us in celebrating the spirit of cricket—let's cheer for our favorite teams, applaud remarkable performances, and revel in the excitement of this beautiful sport.

Thank you for choosing AJ Cricket as your go-to cricket platform. Get ready to immerse yourself in the world of cricket like never before!

Play hard, cheer louder, and enjoy every moment with AJ Cricket!</p>
    </div>
    <div class="flex flex-wrap -m-4 text-center">
      <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
        <div class="border-2 border-gray-200 px-4 py-6 rounded-lg">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="text-indigo-500 w-12 h-12 mb-3 inline-block" viewBox="0 0 24 24">
            <path d="M8 17l4 4 4-4m-4-5v9"></path>
            <path d="M20.88 18.09A5 5 0 0018 9h-1.26A8 8 0 103 16.29"></path>
          </svg>
          <h2 class="title-font font-medium text-3xl text-gray-900">2.8M</h2>
          <p class="leading-relaxed">Views</p>
        </div>
      </div>
      <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
        <div class="border-2 border-gray-200 px-4 py-6 rounded-lg">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="text-indigo-500 w-12 h-12 mb-3 inline-block" viewBox="0 0 24 24">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 00-3-3.87m-4-12a4 4 0 010 7.75"></path>
          </svg>
          <h2 class="title-font font-medium text-3xl text-gray-900">23.3K</h2>
          <p class="leading-relaxed">Followers</p>
        </div>
      </div>
      <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
        <div class="border-2 border-gray-200 px-4 py-6 rounded-lg">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="text-indigo-500 w-12 h-12 mb-3 inline-block" viewBox="0 0 24 24">
            <path d="M3 18v-6a9 9 0 0118 0v6"></path>
            <path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z"></path>
          </svg>
          <h2 class="title-font font-medium text-3xl text-gray-900">74</h2>
          <p class="leading-relaxed">Files</p>
        </div>
      </div>
      <div class="p-4 md:w-1/4 sm:w-1/2 w-full">
        <div class="border-2 border-gray-200 px-4 py-6 rounded-lg">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="text-indigo-500 w-12 h-12 mb-3 inline-block" viewBox="0 0 24 24">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
          <h2 class="title-font font-medium text-3xl text-gray-900">46</h2>
          <p class="leading-relaxed">Places</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="text-gray-600 body-font">
  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-col text-center w-full mb-20">
      <h2 class="text-xs text-green-500 tracking-widest font-medium title-font mb-1 hover:text-black">AJ Cricket</h2>
      <h1 class="sm:text-3xl text-2xl font-medium title-font text-gray-900  hover:text-green-500">A CRICKET WEBSITE</h1>
    </div>
    <div class="flex flex-wrap -m-4">
      <div class="p-4 md:w-1/3">
        <div class="flex rounded-lg h-full bg-gray-100 p-8 flex-col">
          <div class="flex items-center mb-3">
            <div class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full bg-indigo-500 text-white flex-shrink-0">
            <img src="https://scontent.flhe7-2.fna.fbcdn.net/v/t39.30808-6/360103032_679447757532813_3320949709480004465_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=efb6e6&_nc_ohc=r5uznND0uv0AX9o5MFx&_nc_ht=scontent.flhe7-2.fna&oh=00_AfABv2dPzf0sClaYmPqKw6WJ81AapOLeyTfU4khccrUqtw&oe=65A55399" alt="" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-10 h-10 text-white p-0 bg-green-500 rounded-full" viewBox="0 0 24 24"/> 
            </div>
            <h2 class="text-gray-900 text-lg title-font font-medium">UpDates</h2>
          </div>
          <div class="flex-grow">
            <p class="leading-relaxed text-base">We Are Always UpDates on Cricket We're committed to continual improvement and delivering value to you, our valued stakeholders. Your support and feedback have been instrumental in our progress, and we're grateful for your ongoing trust.</p>
            <a class="mt-3 text-indigo-500 inline-flex items-center">Learn More
              <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                <path d="M5 12h14M12 5l7 7-7 7"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="p-4 md:w-1/3">
        <div class="flex rounded-lg h-full bg-gray-100 p-8 flex-col">
          <div class="flex items-center mb-3">
            <div class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full bg-indigo-500 text-white flex-shrink-0">
            <img src="https://scontent.flhe7-2.fna.fbcdn.net/v/t39.30808-6/360103032_679447757532813_3320949709480004465_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=efb6e6&_nc_ohc=r5uznND0uv0AX9o5MFx&_nc_ht=scontent.flhe7-2.fna&oh=00_AfABv2dPzf0sClaYmPqKw6WJ81AapOLeyTfU4khccrUqtw&oe=65A55399" alt="" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-10 h-10 text-white p-0 bg-green-500 rounded-full" viewBox="0 0 24 24"/> 
            </div>
            <h2 class="text-gray-900 text-lg title-font font-medium">Live</h2>
          </div>
          <div class="flex-grow">
            <p class="leading-relaxed text-base">We Are Always Live to describe events or activities that are happening in real-time, without any delay or pre-recorded elements. In various contexts, "live" signifies immediate and unedited content being broadcasted or experienced as it occurs</p>
            <a class="mt-3 text-indigo-500 inline-flex items-center">Learn More
              <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                <path d="M5 12h14M12 5l7 7-7 7"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="p-4 md:w-1/3">
        <div class="flex rounded-lg h-full bg-gray-100 p-8 flex-col">
          <div class="flex items-center mb-3">
            <div class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full bg-indigo-500 text-white flex-shrink-0">
            <img src="https://scontent.flhe7-2.fna.fbcdn.net/v/t39.30808-6/360103032_679447757532813_3320949709480004465_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=efb6e6&_nc_ohc=r5uznND0uv0AX9o5MFx&_nc_ht=scontent.flhe7-2.fna&oh=00_AfABv2dPzf0sClaYmPqKw6WJ81AapOLeyTfU4khccrUqtw&oe=65A55399" alt="" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-10 h-10 text-white p-0 bg-green-500 rounded-full" viewBox="0 0 24 24"/> 
            </div>
            <h2 class="text-gray-900 text-lg title-font font-medium">NO#1</h2>
          </div>
          <div class="flex-grow">
            <p class="leading-relaxed text-base">Certainly! However, since you provided a topic placeholder "no#1," which doesn't specify a particular subject, I'll create a general article to help provide information or guidance on a common topic.</p>
            <a class="mt-3 text-indigo-500 inline-flex items-center">Learn More
              <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                <path d="M5 12h14M12 5l7 7-7 7"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</>
  )
}

export default About
